<template>
    <ShopFilterItem :title="title">
        <ul>
            <li v-for="category in categories" :key="category.id">
                <div class="fui-checkbox">
                    <input
                        :id="`category-${category.id}`"
                        v-model="localValue"
                        :name="`${field}[]`"
                        :value="category.id"
                        type="checkbox"
                    >

                    <label
                        :for="`category-${category.id}`"
                        class="cursor-pointer"
                    >{{ category.title }}</label>
                </div>
            </li>
        </ul>
    </ShopFilterItem>
</template>

<script>
import ShopFilterItem from './ShopFilterItem.vue';

export default {
    components: {
        ShopFilterItem,
    },

    props: {
        title: {
            type: String,
            required: true,
        },
        field: {
            type: String,
            required: true,
        },
        modelValue: {
            type: [Array, Number, String],
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    computed: {
        localValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
};
</script>
